import React, { useEffect, useState } from 'react';
import { Menu, X, Instagram } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/uCcqF3Bmg4nbYwNoTgSckm/heylloyd-image-1776132028113-Photoroom.png';
export function TopBar() {
  return <div className="bg-brand-green text-white text-xs sm:text-sm font-bold text-center py-1.5 sm:py-2 px-4" data-id="element-8">
      🔥 RECURSOS PARA INSTRUCTORAS DE FITNESS · DESCARGÁ · ENSEÑÁ · TRANSFORMÁ
    </div>;
}
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`sticky top-0 z-50 transition-all duration-300 bg-brand-black ${isScrolled ? 'shadow-md shadow-black/20' : 'border-b border-brand-border'}`} data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="flex justify-between items-center h-14 sm:h-20" data-id="element-11">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2" data-id="element-12">
            <img src={LOGO_URL} alt="Logo" className="h-7 sm:h-10 w-auto object-contain brightness-0 invert" data-id="element-13" />
            <span className="font-extrabold text-base sm:text-xl tracking-tight text-white" data-id="element-14">
              recursos<span className="text-brand-green" data-id="element-15">fitness</span>.shop
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-16">
            <a href="#productos" className="text-white font-semibold hover:text-brand-green transition-colors" data-id="element-17">
              Productos
            </a>
            <a href="#testimonios" className="text-white font-semibold hover:text-brand-green transition-colors" data-id="element-18">
              Testimonios
            </a>
            <a href="#contacto" className="text-white font-semibold hover:text-brand-green transition-colors" data-id="element-19">
              Contacto
            </a>
            <a href="https://www.instagram.com/recursosfitness.ar/" target="_blank" rel="noopener noreferrer" className="bg-brand-green hover:bg-green-600 text-white px-5 py-2.5 rounded-full font-bold transition-colors flex items-center gap-2" data-id="element-20">
              📲 @recursosfitness.ar
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-21">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white hover:text-brand-green focus:outline-none" data-id="element-22">
              {mobileMenuOpen ? <X size={24} data-id="element-23" /> : <Menu size={24} data-id="element-24" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden bg-brand-black border-t border-brand-border absolute w-full shadow-lg shadow-black/20" data-id="element-25">
          <div className="px-4 pt-2 pb-4 space-y-1 flex flex-col" data-id="element-26">
            <a href="#productos" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-semibold text-white border-b border-brand-border" data-id="element-27">
              Productos
            </a>
            <a href="#testimonios" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-semibold text-white border-b border-brand-border" data-id="element-28">
              Testimonios
            </a>
            <a href="#contacto" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-semibold text-white border-b border-brand-border" data-id="element-29">
              Contacto
            </a>
            <a href="https://www.instagram.com/recursosfitness.ar/" target="_blank" rel="noopener noreferrer" className="mt-3 mx-3 bg-brand-green text-white px-5 py-2.5 rounded-full font-bold text-center block" data-id="element-30">
              📲 @recursosfitness.ar
            </a>
          </div>
        </div>}
    </nav>;
}
export function Footer() {
  return <footer id="contacto" className="bg-brand-black text-white pt-6 md:pt-16 pb-4 md:pb-8" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        {/* Logo + description - compact on mobile */}
        <div className="flex items-center gap-2 mb-3 md:mb-4 bg-white/10 p-1.5 md:p-2 rounded-lg inline-flex" data-id="element-33">
          <img src={LOGO_URL} alt="Logo" className="h-6 sm:h-12 w-auto object-contain brightness-0 invert" data-id="element-34" />
          <span className="font-extrabold text-sm md:text-xl tracking-tight text-white" data-id="element-35">
            recursos<span className="text-brand-green" data-id="element-36">fitness</span>.shop
          </span>
        </div>
        <p className="text-gray-400 mb-3 md:mb-6 max-w-xs text-xs md:text-base" data-id="element-37">
          Recursos digitales premium para instructoras de fitness en Argentina.
        </p>
        <a href="https://www.instagram.com/recursosfitness.ar/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-brand-green transition-colors inline-block mb-4 md:mb-8" data-id="element-38">
          <Instagram size={20} className="md:w-6 md:h-6" data-id="element-39" />
        </a>

        {/* Productos + Soporte in 2 columns on mobile */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-12 mb-4 md:mb-12" data-id="element-40">
          <div data-id="element-41">
            <h3 className="text-xs md:text-lg font-bold mb-2 md:mb-6 text-white" data-id="element-42">
              Productos
            </h3>
            <ul className="space-y-1 md:space-y-3 text-gray-400 text-[11px] md:text-base" data-id="element-43">
              <li data-id="element-44">
                <a href="https://stretching.recursosfitness.shop/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-45">
                  Stretching Resuelto
                </a>
              </li>
              <li data-id="element-46">
                <a href="https://pilates.rincondocente360.com/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-47">
                  Pilates 360
                </a>
              </li>
              <li data-id="element-48">
                <a href="https://gap.rincondocente360.com/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-49">
                  GAP 360
                </a>
              </li>
              <li data-id="element-50">
                <a href="https://funcional.rincondocente360.com/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-51">
                  Funcional 360
                </a>
              </li>
              <li data-id="element-52">
                <a href="https://pole.recursosfitness.shop/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-53">
                  Pole Resuelto
                </a>
              </li>
              <li data-id="element-54">
                <a href="https://telas.recursosfitness.shop/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-55">
                  Telas Resuelto
                </a>
              </li>
              <li data-id="element-56">
                <a href="https://aquagym.recursosfitness.shop/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-57">
                  Aquagym Resuelto
                </a>
              </li>
              <li data-id="element-58">
                <a href="https://natacion.recursosfitness.shop" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-59">
                  Profe de Natación
                </a>
              </li>
              <li data-id="element-60">
                <a href="https://artistica.recursosfitness.shop/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-61">
                  Gimnasia Artística
                </a>
              </li>
              <li data-id="element-62">
                <a href="https://ritmica.recursosfitness.shop" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-63">
                  Gimnasia Rítmica Infantil
                </a>
              </li>
              <li data-id="element-64">
                <a href="https://futbol.recursosfitness.shop" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-65">
                  Megapack Fútbol
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-66">
            <h3 className="text-xs md:text-lg font-bold mb-2 md:mb-6 text-white" data-id="element-67">
              Soporte
            </h3>
            <ul className="space-y-1 md:space-y-3 text-gray-400 text-[11px] md:text-base" data-id="element-68">
              <li data-id="element-69">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-70">
                  Preguntas Frecuentes
                </a>
              </li>
              <li data-id="element-71">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-72">
                  Política de Devolución
                </a>
              </li>
              <li data-id="element-73">
                <a href="#contacto" className="hover:text-brand-green transition-colors" data-id="element-74">
                  Contacto
                </a>
              </li>
              <li data-id="element-75">
                <a href="https://www.instagram.com/recursosfitness.ar/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors" data-id="element-76">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-3 md:pt-8 text-center text-gray-500 text-[10px] md:text-sm flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-2" data-id="element-77">
          <span data-id="element-78">© 2026 recursosfitness.shop</span>
          <span className="hidden sm:inline" data-id="element-79">·</span>
          <span data-id="element-80">Todos los derechos reservados</span>
          <span className="hidden sm:inline" data-id="element-81">·</span>
          <span data-id="element-82">@recursosfitness.ar</span>
        </div>

        {/* Anti-Distribution Disclaimer */}
        <div id="aviso-legal" className="mt-3 md:mt-6 border-t border-gray-800/50 pt-3 md:pt-5" data-id="element-83">
          <div className="max-w-3xl mx-auto text-center" data-id="element-84">
            <div className="flex items-center justify-center gap-1.5 mb-1.5 md:mb-2" data-id="element-85">
              <span className="text-red-500 text-xs md:text-sm" data-id="element-86">🔒</span>
              <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-gray-400" data-id="element-87">
                Aviso Legal · Propiedad Intelectual
              </span>
            </div>
            <p className="text-[9px] md:text-[11px] leading-relaxed text-gray-600 max-w-2xl mx-auto" data-id="element-88">
              Todo el contenido disponible en{' '}
              <span className="text-gray-400 font-semibold" data-id="element-89">
                recursosfitness.shop
              </span>{' '}
              — incluyendo textos, diseños, planificaciones, imágenes,
              estructura y materiales descargables — es de autoría exclusiva y
              propiedad intelectual de recursosfitness.shop. Queda
              terminantemente prohibida su reproducción, distribución, reventa,
              modificación o difusión total o parcial sin autorización expresa
              por escrito. Todos los productos contienen{' '}
              <span className="text-gray-400 font-semibold" data-id="element-90">
                marcas de agua digitales y sistemas de trazabilidad
              </span>{' '}
              que permiten identificar el origen de cualquier copia no
              autorizada. El incumplimiento de estas condiciones será perseguido
              conforme a la legislación vigente en materia de propiedad
              intelectual y derechos de autor.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}
export function FloatingButton() {
  return <a href="https://www.instagram.com/recursosfitness.ar/" target="_blank" rel="noopener noreferrer" className="fixed bottom-5 right-5 z-50 w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300" style={{
    background: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)'
  }} data-id="element-91">
      <Instagram className="w-6 h-6 md:w-7 md:h-7 text-white" data-id="element-92" />
    </a>;
}
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-93">
      <Navbar data-id="element-94" />
      <main className="flex-grow" data-id="element-95">{children}</main>
      <Footer data-id="element-96" />
      <FloatingButton data-id="element-97" />
    </div>;
}